export const ORIGINAL_PDB_CHAIN_IDS = new Set([
  "1a1p_a",
  "1acw_a",
  "1ag7_a",
  "1agt_a",
  "1ahl_a",
  "1akg_a",
  "1ans_a",
  "1apf_a",
  "1as5_a",
  "1atx_a",
  "1axh_a",
  "1ayj_a",
  "1az6_a",
  "1azj_a",
  "1azk_a",
  "1b41_a",
  "1b45_a",
  "1b5n_a",
  "1b8w_a",
  "1bah_a",
  "1bcg_a",
  "1bei_a",
  "1bf0_a",
  "1bgk_a",
  "1bh4_a",
  "1bhp_a",
  "1big_a",
  "1bk8_a",
  "1bkt_a",
  "1bnb_a",
  "1bqf_a",
  "1brv_a",
  "1bte_a",
  "1bte_b",
  "1bun_a",
  "1bun_b",
  "1c01_a",
  "1c2u_a",
  "1c49_a",
  "1c4e_a",
  "1c56_a",
  "1c6w_a",
  "1cdr_a",
  "1cdt_b",
  "1chl_a",
  "1chv_s",
  "1chz_a",
  "1cix_a",
  "1clv_a",
  "1clv_i",
  "1cmr_a",
  "1cnl_a",
  "1cnn_a",
  "1coe_a",
  "1crf_a",
  "1ctx_a",
  "1cvo_a",
  "1cw5_a",
  "1cw6_a",
  "1cz6_a",
  "1d1h_a",
  "1d5q_a",
  "1dan_h",
  "1dan_l",
  "1dan_t",
  "1dan_u",
  "1dem_a",
  "1df6_a",
  "1dfn_a",
  "1djt_b",
  "1dkc_a",
  "1dl0_a",
  "1drs_a",
  "1dtk_a",
  "1dtx_a",
  "1du9_a",
  "1e74_a",
  "1e75_a",
  "1e76_a",
  "1ed0_a",
  "1edn_a",
  "1edp_a",
  "1ehh_a",
  "1ehs_a",
  "1eis_a",
  "1eit_a",
  "1emx_a",
  "1en2_a",
  "1es7_b",
  "1es7_d",
  "1eth_a",
  "1eth_d",
  "1etl_a",
  "1etm_a",
  "1etn_a",
  "1ews_a",
  "1eyo_a",
  "1f2s_i",
  "1f3k_a",
  "1f8u_a",
  "1f8u_b",
  "1fas_a",
  "1feo_a",
  "1ff4_a",
  "1ffj_a",
  "1fh3_a",
  "1fjn_a",
  "1fqq_a",
  "1fss_a",
  "1fu3_a",
  "1fvl_a",
  "1fyg_a",
  "1g1z_a",
  "1g6m_a",
  "1g9p_a",
  "1gib_a",
  "1gm2_a",
  "1gna_a",
  "1gps_a",
  "1gpt_a",
  "1h20_a",
  "1h5o_a",
  "1h9h_e",
  "1h9h_i",
  "1h9i_e",
  "1h9i_i",
  "1hje_a",
  "1hly_a",
  "1hp2_a",
  "1hp3_a",
  "1hp9_a",
  "1hrl_a",
  "1hvw_a",
  "1hvz_a",
  "1hy9_a",
  "1hyk_a",
  "1i25_a",
  "1i26_a",
  "1i2u_a",
  "1i2v_a",
  "1i6g_a",
  "1i6y_a",
  "1i8e_a",
  "1i8n_a",
  "1i93_a",
  "1ib9_a",
  "1ic9_a",
  "1ica_a",
  "1icl_a",
  "1ico_a",
  "1idg_a",
  "1ie6_a",
  "1ien_a",
  "1ieo_a",
  "1igx_a",
  "1ijc_a",
  "1im7_a",
  "1imt_a",
  "1iod_a",
  "1iod_b",
  "1iod_g",
  "1iqb_a",
  "1iva_a",
  "1ixt_a",
  "1j2l_a",
  "1j35_a",
  "1j35_b",
  "1j35_c",
  "1j5j_a",
  "1j8n_a",
  "1jbf_a",
  "1jbn_a",
  "1jc6_a",
  "1je9_a",
  "1jgk_a",
  "1jjz_a",
  "1jkz_a",
  "1jlp_a",
  "1jlz_a",
  "1jmn_a",
  "1jmp_a",
  "1ju8_a",
  "1jxc_a",
  "1jza_b",
  "1k64_a",
  "1kal_a",
  "1kb8_a",
  "1kba_a",
  "1kcn_a",
  "1kco_a",
  "1kcp_a",
  "1kg1_a",
  "1kj6_a",
  "1koz_a",
  "1kqi_a",
  "1ktx_a",
  "1ktz_a",
  "1ktz_b",
  "1ku6_a",
  "1kv0_a",
  "1kve_c",
  "1kve_d",
  "1kwe_a",
  "1l3x_a",
  "1l4v_a",
  "1la4_a",
  "1lfc_a",
  "1lir_a",
  "1lmm_a",
  "1lmr_a",
  "1lpb_a",
  "1lqq_a",
  "1lsi_a",
  "1lu0_b",
  "1lu8_a",
  "1lup_a",
  "1lx5_a",
  "1m2s_a",
  "1m4e_a",
  "1m4f_a",
  "1m9z_a",
  "1mah_a",
  "1mb6_a",
  "1mct_a",
  "1mct_i",
  "1mcv_a",
  "1mcv_i",
  "1mii_a",
  "1mm0_a",
  "1mmc_a",
  "1mpz_a",
  "1mr0_a",
  "1mr6_a",
  "1mtq_a",
  "1mtx_a",
  "1mvj_a",
  "1mxn_a",
  "1myn_a",
  "1n1u_a",
  "1n2y_a",
  "1n4n_a",
  "1n8m_a",
  "1n8s_a",
  "1n8s_c",
  "1nb1_a",
  "1nbj_a",
  "1nbl_a",
  "1ne5_a",
  "1nea_a",
  "1nil_a",
  "1nix_a",
  "1niy_a",
  "1nkl_a",
  "1npi_a",
  "1nra_a",
  "1ntn_a",
  "1ntx_a",
  "1nxb_a",
  "1nys_a",
  "1nys_b",
  "1nys_c",
  "1nys_d",
  "1nyu_a",
  "1nyu_b",
  "1nyu_c",
  "1nyu_d",
  "1o83_c",
  "1of9_a",
  "1oma_a",
  "1omb_a",
  "1omc_a",
  "1omg_a",
  "1omy_a",
  "1onj_a",
  "1orl_a",
  "1orx_a",
  "1ozz_a",
  "1p00_a",
  "1p0a_a",
  "1p1p_a",
  "1p8b_a",
  "1p9g_a",
  "1pan_a",
  "1pcn_a",
  "1pe4_a",
  "1pen_a",
  "1pjv_a",
  "1plo_a",
  "1pnh_a",
  "1ppe_i",
  "1pqr_a",
  "1pt4_a",
  "1pvz_a",
  "1pxq_a",
  "1q2j_a",
  "1q2k_a",
  "1q3j_a",
  "1q7j_a",
  "1q9b_a",
  "1qdp_a",
  "1qfb_a",
  "1qk6_a",
  "1qk7_a",
  "1qkd_a",
  "1qky_a",
  "1qm7_a",
  "1quz_a",
  "1qvk_a",
  "1qx9_a",
  "1r02_a",
  "1r1f_a",
  "1r1g_a",
  "1r9i_a",
  "1rc9_a",
  "1rew_c",
  "1rew_d",
  "1rgj_b",
  "1rkk_a",
  "1rmk_a",
  "1rmr_a",
  "1roo_a",
  "1rpc_a",
  "1ryg_a",
  "1ryv_a",
  "1s4y_a",
  "1s4y_b",
  "1s4y_d",
  "1s6w_a",
  "1sco_a",
  "1scy_a",
  "1seg_a",
  "1sh1_a",
  "1sis_a",
  "1ski_a",
  "1skk_a",
  "1skl_a",
  "1sn4_a",
  "1snb_a",
  "1srb_a",
  "1sxm_a",
  "1t0w_a",
  "1t0z_b",
  "1t1t_a",
  "1t7a_a",
  "1t7b_a",
  "1t7e_a",
  "1t7h_a",
  "1t9e_a",
  "1tcj_a",
  "1tck_a",
  "1tej_a",
  "1tej_b",
  "1ter_a",
  "1tfs_a",
  "1tgx_a",
  "1toc_h",
  "1toc_t",
  "1tr6_a",
  "1tsk_a",
  "1tt3_a",
  "1tv0_a",
  "1txb_a",
  "1txm_a",
  "1ueo_a",
  "1ug4_a",
  "1ugl_a",
  "1uha_a",
  "1ul2_a",
  "1uoy_a",
  "1ut3_a",
  "1uyb_a",
  "1v28_a",
  "1v4q_a",
  "1v7f_a",
  "1vb8_a",
  "1vib_a",
  "1vna_a",
  "1vtx_a",
  "1w6b_a",
  "1w7z_a",
  "1w7z_h",
  "1wct_a",
  "1wkx_a",
  "1wm7_a",
  "1wm8_a",
  "1wmt_a",
  "1wo1_a",
  "1wo9_a",
  "1wpd_a",
  "1wq8_a",
  "1wq9_a",
  "1wq9_b",
  "1wqb_a",
  "1wt7_a",
  "1wt8_a",
  "1wuw_b",
  "1wwn_a",
  "1wz5_a",
  "1xdt_r",
  "1xdt_t",
  "1xgb_a",
  "1xj1_a",
  "1y29_a",
  "1y58_a",
  "1yi5_a",
  "1yi5_b",
  "1yi5_c",
  "1yi5_d",
  "1yi5_e",
  "1yi5_i",
  "1yi5_j",
  "1yp8_a",
  "1ywh_i",
  "1ywh_k",
  "1ywh_m",
  "1ywh_o",
  "1yz2_a",
  "1za8_a",
  "1zad_a",
  "1zlc_a",
  "1zlh_a",
  "1zli_a",
  "1zlo_a",
  "1zmi_d",
  "1zmm_b",
  "1zmm_c",
  "1zmq_d",
  "1zu3_a",
  "1zue_a",
  "1zuf_a",
  "1zut_a",
  "1zve_a",
  "1zvg_a",
  "1zy6_a",
  "1zyv_a",
  "1zyw_a",
  "2a2v_a",
  "2a7t_a",
  "2ab9_a",
  "2abx_a",
  "2ajw_a",
  "2ak0_a",
  "2aks_a",
  "2asc_a",
  "2atb_a",
  "2b38_a",
  "2b3c_a",
  "2b5k_a",
  "2b68_a",
  "2bds_a",
  "2bey_a",
  "2bmt_a",
  "2btc_i",
  "2c4b_a",
  "2ca7_a",
  "2cbh_a",
  "2ccx_a",
  "2cdx_a",
  "2crt_a",
  "2e3e_a",
  "2e3f_a",
  "2e3g_a",
  "2ech_a",
  "2efz_a",
  "2era_a",
  "2eri_a",
  "2ew4_a",
  "2f2i_a",
  "2f2j_a",
  "2fqa_a",
  "2fqc_a",
  "2fr9_a",
  "2frb_a",
  "2g9l_a",
  "2gj0_a",
  "2gl1_a",
  "2goo_b",
  "2goo_c",
  "2goo_d",
  "2goo_e",
  "2goo_f",
  "2gwp_a",
  "2h5f_a",
  "2h5f_b",
  "2h62_c",
  "2h62_d",
  "2h64_a",
  "2h64_b",
  "2h64_c",
  "2h7z_a",
  "2h7z_b",
  "2h8s_a",
  "2h8u_a",
  "2h9x_a",
  "2i61_a",
  "2ifi_a",
  "2ifj_a",
  "2ih7_a",
  "2iha_a",
  "2it7_a",
  "2it8_a",
  "2j15_a",
  "2j6d_a",
  "2jni_a",
  "2jot_a",
  "2jqp_a",
  "2jry_a",
  "2jsb_a",
  "2jtb_a",
  "2jto_a",
  "2juq_a",
  "2jur_a",
  "2jus_a",
  "2jwm_a",
  "2k10_a",
  "2k1i_a",
  "2k3g_a",
  "2k4u_a",
  "2k7g_a",
  "2kbh_a",
  "2kbk_a",
  "2kcg_a",
  "2kcr_a",
  "2kja_a",
  "2kjf_a",
  "2km9_a",
  "2kni_a",
  "2knj_a",
  "2knn_a",
  "2kra_a",
  "2ktc_a",
  "2kuk_a",
  "2kux_a",
  "2kvx_a",
  "2ky3_a",
  "2kyq_a",
  "2l37_a",
  "2l3i_a",
  "2lam_a",
  "2lb7_a",
  "2let_a",
  "2lew_a",
  "2ley_a",
  "2lg4_a",
  "2li7_a",
  "2lj7_a",
  "2ljm_a",
  "2ljs_a",
  "2ljv_a",
  "2lkb_a",
  "2lld_a",
  "2lmz_a",
  "2lo9_a",
  "2lu9_a",
  "2lur_a",
  "2lxz_a",
  "2ly5_a",
  "2lz5_a",
  "2lzi_a",
  "2m01_a",
  "2m3i_a",
  "2m3n_a",
  "2m4z_a",
  "2m50_a",
  "2m62_a",
  "2m75_a",
  "2m7f_a",
  "2m7h_a",
  "2m86_a",
  "2m8b_b",
  "2m99_a",
  "2m9o_a",
  "2md6_a",
  "2me7_a",
  "2mel_a",
  "2men_a",
  "2meo_a",
  "2mg6_a",
  "2mh1_a",
  "2mj0_a",
  "2mj4_a",
  "2mla_a",
  "2mld_a",
  "2mn1_a",
  "2mop_1",
  "2mpq_a",
  "2mqf_a",
  "2mso_a",
  "2msq_a",
  "2mt8_a",
  "2mw0_a",
  "2mwr_a",
  "2mxo_a",
  "2mxq_a",
  "2n1s_a",
  "2n24_a",
  "2n2r_a",
  "2n66_a",
  "2n69_a",
  "2n7f_a",
  "2n8e_a",
  "2n8h_a",
  "2nay_a",
  "2ndb_a",
  "2ny8_x",
  "2ny9_x",
  "2nz3_a",
  "2ody_d",
  "2ody_f",
  "2ofs_a",
  "2otq_a",
  "2ox2_a",
  "2p4l_a",
  "2pjf_a",
  "2pjg_a",
  "2pji_a",
  "2pjy_a",
  "2pjy_b",
  "2pjy_c",
  "2plh_a",
  "2po8_a",
  "2pta_a",
  "2puq_l",
  "2puq_t",
  "2qc1_a",
  "2qc1_b",
  "2qj9_b",
  "2qj9_c",
  "2qj9_d",
  "2qja_c",
  "2qja_d",
  "2qjb_c",
  "2qjb_d",
  "2sn3_a",
  "2stb_e",
  "2uvs_a",
  "2uwr_a",
  "2ux2_a",
  "2v9b_b",
  "2w9o_a",
  "2w9u_a",
  "2w9v_a",
  "2w9w_a",
  "2x8b_a",
  "2ybr_a",
  "2ybr_b",
  "2ybr_e",
  "2ybr_g",
  "2ybr_h",
  "2yc1_a",
  "2yc1_b",
  "2yc1_c",
  "2yen_a",
  "2yeo_a",
  "2z3s_a",
  "3bt1_a",
  "3bt1_b",
  "3bt1_u",
  "3bt2_a",
  "3bt2_h",
  "3bt2_l",
  "3bt2_u",
  "3byb_a",
  "3byb_b",
  "3c05_a",
  "3c05_b",
  "3c05_c",
  "3c05_d",
  "3c59_a",
  "3c5t_a",
  "3c8p_b",
  "3d4u_a",
  "3d65_i",
  "3e4h_a",
  "3ebx_a",
  "3era_b",
  "3evs_b",
  "3evs_c",
  "3hh7_a",
  "3kfd_d",
  "3kfd_e",
  "3kfd_g",
  "3kfd_h",
  "3kfd_k",
  "3kfd_l",
  "3lms_a",
  "3lms_b",
  "3nh7_h",
  "3nh7_i",
  "3nh7_j",
  "3nh7_k",
  "3nh7_o",
  "3p8f_a",
  "3plc_a",
  "3plc_c",
  "3psm_b",
  "3qb4_a",
  "3qb4_b",
  "3qb4_c",
  "3qb4_d",
  "3szs_a",
  "3th2_t",
  "3th3_l",
  "3th3_t",
  "3th4_t",
  "3uci_a",
  "3uir_a",
  "3uir_b",
  "3uir_d",
  "3vts_b",
  "3zkt_a",
  "4ab0_a",
  "4abi_b",
  "4abj_a",
  "4abj_b",
  "4aei_c",
  "4aei_h",
  "4aei_i",
  "4aei_j",
  "4aei_l",
  "4aei_m",
  "4aml_a",
  "4aml_b",
  "4b1q_p",
  "4bdt_a",
  "4bvv_a",
  "4cpa_a",
  "4cpa_i",
  "4cqk_n",
  "4ec7_b",
  "4ey8_a",
  "4hgc_i",
  "4iye_a",
  "4jtc_y",
  "4jtd_y",
  "4kyp_c",
  "4kyp_d",
  "4lft_a",
  "4lft_b",
  "4m4c_c",
  "4ntx_a",
  "4ntx_b",
  "4ntx_c",
  "4nty_a",
  "4om5_d",
  "4p7u_a",
  "4r5r_b",
  "4r5u_a",
  "4rqg_b",
  "4ttm_a",
  "4ttn_a",
  "4tto_a",
  "4uj0_a",
  "4uj0_b",
  "4uy2_b",
  "4uy2_d",
  "4v1d_a",
  "4v1d_b",
  "4v1d_c",
  "4v1d_d",
  "4v1d_e",
  "4x9z_a",
  "4x9z_b",
  "4xl1_a",
  "4xl1_b",
  "4xl1_d",
  "4xl1_e",
  "4z6a_h",
  "4z6a_l",
  "4z6a_t",
  "4zma_h",
  "4zma_l",
  "4zma_t",
  "4zqy_b",
  "5ax2_a",
  "5e5q_b",
  "5f84_a",
  "5f84_b",
  "5hbt_b",
  "5hbt_c",
  "5hbv_c",
  "5hbv_d",
  "5imt_d",
  "5imy_a",
  "5imy_b",
  "5kxh_a",
  "5kxh_b",
  "5ky0_a",
  "5ky0_b",
  "5ky2_a",
  "5ky2_b",
  "5ky4_a",
  "5ky4_b",
  "5ky8_a",
  "5ky8_b",
  "5ky9_a",
  "5ky9_b",
  "5l34_a",
  "5lue_a",
  "5m9u_a",
  "5mou_a",
  "5nce_a",
  "5ngv_a",
  "5ngv_h",
  "5ngv_l",
  "5oll_a",
  "5t3m_a",
  "5tx4_a",
  "5tx4_b",
  "5ty4_a",
  "5ty4_b",
  "5ug3_a",
  "5ug5_a",
  "5vyp_h",
  "5vyp_k",
  "5vyp_l",
  "5vyp_n",
  "5wov_a",
  "5wow_a",
  "5wuz_a",
  "5xdi_a",
  "5xo3_a",
  "5xo4_a",
  "5xo5_a",
  "5xwe_a",
  "5xwe_b",
  "5y0h_a",
  "5zv6_a",
  "6a5i_a",
  "6aex_u",
  "6atl_a",
  "6atl_c",
  "6atm_c",
  "6atn_a",
  "6atu_d",
  "6atu_h",
  "6atu_l",
  "6atu_n",
  "6au7_c",
  "6av8_a",
  "6ava_a",
  "6ava_b",
  "6avc_a",
  "6avd_a",
  "6ay7_b",
  "6b55_t",
  "6ceg_a",
  "6cei_a",
  "6cgx_a",
  "6d3t_a",
  "6d8h_a",
  "6d8q_a",
  "6d8r_a",
  "6d8s_a",
  "6d8t_a",
  "6d8u_a",
  "6d8y_a",
  "6d93_a",
  "6d9o_a",
  "6d9p_a",
  "6dhr_a",
  "6efe_a",
  "6gft_a",
  "6imf_a",
  "6imf_b",
  "6jic_a",
  "6lcq_a",
  "6lsq_a",
  "6lsq_b",
  "6mac_a",
  "6mac_c",
  "6mac_k",
  "6mry_j",
  "6mry_l",
  "6my2_a",
  "6mzt_a",
  "6nom_a",
  "6ohx_a",
  "6otb_a",
  "6pi2_a",
  "6pi3_a",
  "6pin_a",
  "6pio_a",
  "6pip_a",
  "6pnw_a",
  "6q5z_a",
  "6q61_a",
  "6q6c_a",
  "6q6c_b",
  "6qeu_a",
  "6rc7_a",
  "6sf1_a",
  "6sf3_b",
  "6thi_a",
  "6u6g_a",
  "6v6t_a",
  "6vnz_a",
  "6vpn_a",
  "6vxw_a",
  "6wjc_a",
  "6wjc_c",
  "6yht_a",
  "6yhy_a",
  "6zoi_d",
  "6zoi_e",
  "7c28_a",
  "7c28_b",
  "7k7x_a",
  "7kpd_a",
  "7lhc_a",
  "7n0t_a",
  "7n1z_a",
  "7n21_a",
  "7n23_a",
  "7n25_a",
  "7o2k_a",
  "7rc7_a",
  "7rc8_a",
  "7rfa_a",
  "7rij_a",
  "7rmq_a",
  "7rn3_a",
  "7t10_a",
  "7t10_p",
  "7t10_r",
  "7t10_s",
  "7tvq_a",
  "7yoa_a",
  "9fjy_e",
  "9fjy_g",
]);
